import React, {Fragment, useState} from "react";
import whitelogo from "../../assets/images/header/logo.svg";
import logout from "../../assets/images/header/logout.svg";
//import HeaderCSS from "./Header.module.css";
import HeaderCSS from "./Header.module.scss";
import {useDispatch, useSelector} from "react-redux";
import {logOut} from "../../reducers/session";
import {useNavigate} from "react-router";
import {Link} from "react-router-dom";
import {appRoutesConst} from "app/navigation";
import {Modal, Button} from "antd";
import {Dropdown} from "react-bootstrap";
import {actions as plansActions} from "../../reducers/plans";
// import PlanListing from "components/Home/PlanListing";
import HomePricingCSS from "../Home/HomePricing.module.scss";

import {
  addAddvMindsCancelSubscriptionAPI,
  addAddvMindsUpgradeSubscriptionAPI,
  geClinicianSubscribedtPlanAPI,
} from "services/plans";
import {errorToast, getErrorObject, successToast} from "utilities/utils";
import {get} from "lodash";
import Nodata from "../../components/common/Nodata";
import nodataimg from "assets/images/common/nodata.svg";
import Loader from "../common/PageLoader";
// import remove_record from "assets/images/common/remove_record.svg";
// import removeIcon from "assets/images/common/removeIcon.svg";

import moment from "moment";
import HomePricingCard from "components/Home/HomePricingCard";
import NoTabledata from "./NoTabledata";
// import FloatLabel from "./FloatLabel";

const Header = (props) => {
  // console.log("props-->", props);
  const [userModalOpen, setUserModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isDeleting, setisDeleting] = useState(false);
  const [planListModalOpen, setPlanListModalOpen] = useState(false);
  const [plan, setPlan] = useState([]);
  const dispatch = useDispatch();
  const navigateTo = useNavigate();
  const navigate = useNavigate();
  const {user, is_signin} = useSelector((state) => state.localStore);

  const {
    data: plansData,
    ids: plansIds,
    isLoading: plansLoading,
  } = useSelector((state) => state.plans);
  // useEffect(() => {
  //   return () => {};
  //   // eslint-disable-next-line
  // }, []);
  // console.log("state user-->", Object.keys(plan));
  const onLogut = () => {
    dispatch(logOut(navigate));
  };
  const handlePlanDetails = async () => {
    setUserModalOpen(true);

    try {
      setIsLoading(true);
      const response = await geClinicianSubscribedtPlanAPI({
        // vantage_subscription_plan_id: id,
      });

      if (response.data.data) {
        setPlan(response.data.data);
        setIsLoading(false);
      }
      setIsLoading(false);
    } catch (error) {
      // const {message} = getErrorObject(error);
      setIsLoading(false);

      // errorToast({content: message}); //error message hide as per QA
    }
    return;
  };
  const handleCancelSubscription = (id, status) => {
    Modal.confirm({
      title: `${status === "cancel" ? "Cancel" : "Upgrade"} Subscription`,
      content: `Are you sure want to ${
        status === "cancel" ? "cancel" : "upgrade"
      } this plan?`,
      icon: status === "cancel" && "",
      okButtonProps: {
        loading: isDeleting,
        className: "dlt_mdl_ok_btn",
        disabled: isDeleting,
      },
      className: `delete_modal poplistcancel`,
      okText: "Ok",
      cancelText: "Cancel",
      cancelButtonProps: {
        className: "dlt_mdl_cancel_btn",
      },
      onOk: async () => {
        let data = {};
        if (status === "upgrade") {
          data = {
            direct_clinician_id: user && user.id,

            vantage_subscription_plan_id: id,
          };
        } else {
          data = {
            direct_clinician_id: user && user.id,
          };
        }
        try {
          await setisDeleting(true);
          let response;
          if (status === "cancel") {
            response = await addAddvMindsCancelSubscriptionAPI(data);
          } else {
            response = await addAddvMindsUpgradeSubscriptionAPI(data);
          }
          if (response.data.message) {
            successToast({content: response.data.message});
            setUserModalOpen(false);
            setPlanListModalOpen(false);
            setPlan([]);
            await setisDeleting(false);
          }
          // await setisDeleting(false);
        } catch (error) {
          const {message} = getErrorObject(error);
          errorToast({content: message});
          setisDeleting(false);
        }
      },
    });
  };
  const handleUpgradePlan = async () => {
    setPlanListModalOpen(true);
    await dispatch(plansActions.onRequest({}));
    if (plansIds.length > 0) {
    }
    // console.log("plans data==>", plansData);
  };
  // console.log(
  //   "cancell==>?",
  //   plan[Object.keys(plan)],
  //   plan && Object.keys(plan)[0].in_cancellation_process
  // );
  return (
    <Fragment>
      {isDeleting ? <Loader /> : null}

      <div className={HeaderCSS.header_wrapper}>
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-md-8">
              <h1 className="m-0 display-inline-block line-height-1 vertical-middle font-initial">
                <Link className={HeaderCSS.logo_link} to="/" title="Home Link">
                  <img
                    alt="ADD Vantage Minds"
                    title="ADD Vantage Minds"
                    src={whitelogo}
                    width="180"
                  ></img>
                </Link>
              </h1>

              {!props.isFromPlanListing && (
                <p className="m-0 font-14 weight-500 display-inline-block text-white vertical-middle">
                  {is_signin ? (
                    <span className={HeaderCSS.username}>
                      Hello! {user && user.name ? `${user.name}` : " "}
                    </span>
                  ) : (
                    <span className={HeaderCSS.username}>
                      Hello!{" "}
                      {user && user.first_name
                        ? `${user.first_name} ${user.last_name}`
                        : " "}
                    </span>
                  )}
                </p>
              )}
            </div>
            {!props.isFromPlanListing && (
              <div className="col-md-4">
                {!props.fromResult && (
                  <div
                    className={`d-flex justify-content-end ${HeaderCSS.userprofiledrop}`}
                  >
                    <Dropdown>
                      {user && (
                        <Dropdown.Toggle
                          id="dropdown-basic"
                          className={`${HeaderCSS.userdrp}`}
                        >
                          {is_signin
                            ? user && user.name
                              ? `${user.name}`
                              : " "
                            : user && user.first_name
                            ? `${user.first_name} ${user.last_name}`
                            : " "}
                        </Dropdown.Toggle>
                      )}

                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => handlePlanDetails()}>
                          Subscription
                        </Dropdown.Item>
                        <Dropdown.Item onClick={onLogut}> Logout</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                )}
              </div>
            )}
            {!user && (
              <div className="col-md-4">
                <div className="d-flex justify-content-end">
                  <span
                    onClick={() => {
                      navigateTo(appRoutesConst.signin);
                    }}
                    className={HeaderCSS.logout_link}
                  >
                    Login
                    <div className={HeaderCSS.logout}>
                      {/* <div className={HeaderCSS.doorway}>
                        <div className={HeaderCSS.door}></div>
                      </div> */}
                      <div className={HeaderCSS.arrow}>
                        <img alt="Logout" title="Logout" src={logout}></img>
                      </div>
                    </div>
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {userModalOpen && (
        <Modal
          title={"Plan information"}
          visible={userModalOpen}
          onOk={() => {
            setUserModalOpen(false);
            setPlan([]);
          }}
          onCancel={() => {
            setUserModalOpen(false);
            setPlan([]);
          }}
          centered
          closable={false}
          maskStyle={{backgroundColor: "rgba(0,0,0,.89)"}}
          cancelText="Cancel"
          width={450}
          className="planinfomodal"
        >
          <Fragment>
            {isLoading ? <Loader /> : null}
            {!isLoading && plan.length === 0 && (
              <Nodata subHeading={"No plans found"} image={nodataimg} />
            )}
            {!isLoading && plan.length !== 0 && Object.keys(plan) && (
              <Fragment>
                <div className="parent_spacingdiv">
                  <h5 className="text-capitalize">
                    Plan Name:{" "}
                    {plan[Object.keys(plan)] &&
                    plan[Object.keys(plan)].plan_name
                      ? plan[Object.keys(plan)].plan_name
                      : "-"}
                  </h5>
                  <p className="text-capitalize">
                    Session Type:{" "}
                    {plan[Object.keys(plan)] &&
                    plan[Object.keys(plan)].session_type === "video_emdr"
                      ? "Video + EMDR"
                      : plan[Object.keys(plan)] &&
                        plan[Object.keys(plan)].session_type
                      ? plan[Object.keys(plan)].session_type
                      : "-"}
                  </p>
                  <p className="text-capitalize">
                    Trial Period (days):{" "}
                    {plan[Object.keys(plan)].trial_period_days
                      ? plan[Object.keys(plan)].trial_period_days
                      : "-"}
                  </p>
                  <p>
                    Subscribed At:{" "}
                    {plan[Object.keys(plan)].subscribed_at
                      ? moment(plan[Object.keys(plan)].subscribed_at).format(
                          "DD-MM-YYYY hh:mm A"
                        )
                      : "-"}
                  </p>
                  <p>
                    Free Sessions:{" "}
                    {get(
                      plan[Object.keys(plan)],
                      "free_consultations_count",
                      " -"
                    ) !== null
                      ? `${get(
                          plan[Object.keys(plan)],
                          "used_free_sessions_count",
                          " -"
                        )}
                    /
                    ${get(
                      plan[Object.keys(plan)],
                      "free_consultations_count",
                      " -"
                    )}`
                      : "Unlimited"}
                    {/* {get(
                      plan[Object.keys(plan)],
                      "used_free_sessions_count",
                      " -"
                    )}
                    /
                    {get(
                      plan[Object.keys(plan)],
                      "free_consultations_count",
                      " -"
                    )} */}
                  </p>
                  <p className="text-capitalize">
                    Used Paid Sessions:{" "}
                    {get(
                      plan[Object.keys(plan)],
                      "used_paid_sessions_count",
                      " -"
                    )}
                  </p>
                  <p className="text-capitalize">
                    Total Used Sessions:
                    {get(
                      plan[Object.keys(plan)],
                      "total_used_sessions_count",
                      " -"
                    )}
                  </p>
                  {(Object.keys(plan)[0] === "subscription_usage_details" ||
                    plan[Object.keys(plan)].plan_type ===
                      "paid_by_employee") && (
                    <Fragment>
                      <div className="planinfobtns d-flex align-items-center">
                        {!plan[Object.keys(plan)].in_cancellation_process && (
                          <Button
                            onClick={() =>
                              handleCancelSubscription(
                                plan[Object.keys(plan)].id,
                                "cancel"
                              )
                            }
                            className="ultrasmall-btn"
                            type="danger"
                            disabled={isDeleting}
                          >
                            Cancel Subscription
                          </Button>
                        )}
                        {plan[Object.keys(plan)].status !==
                          "about_to_upgrade" && (
                          <Button
                            onClick={handleUpgradePlan}
                            type="primary"
                            disabled={isDeleting}
                            style={{marginLeft: "10px"}}
                            className="ultrasmall-btn"
                          >
                            Upgrade Subscription
                          </Button>
                        )}
                      </div>
                    </Fragment>
                  )}
                </div>
              </Fragment>
            )}
          </Fragment>
        </Modal>
      )}
      {planListModalOpen && (
        <Modal
          title={"Plan List"}
          visible={planListModalOpen}
          onOk={() => setPlanListModalOpen(false)}
          onCancel={() => setPlanListModalOpen(false)}
          centered
          closable={false}
          maskStyle={{backgroundColor: "rgba(0,0,0,.89)"}}
          // cancelText="Cancel"
          width={950}
          className="planlistmodal"
        >
          <div className={`planlistpricing ${HomePricingCSS.HomePricing}`}>
            {plansIds && plansIds.length === 0 && !plansLoading && (
              <NoTabledata
                subHeading={"No Plan Listing Available"}
                // image={no_appointment}
              />
            )}
            {plansLoading && <Loader />}
            <div
              className={`planmodalpart ${HomePricingCSS.PricingCardWrapper}`}
            >
              {!plansLoading &&
                plansIds
                  .slice(0, 3)
                  .reverse()
                  .map((id, index) => {
                    return (
                      <HomePricingCard
                        fromHeader={true}
                        key={index}
                        data={plansData[id]}
                        handleCancelSubscription={handleCancelSubscription}
                      />
                    );
                  })}
            </div>
          </div>
          {/* // <PlanListing */}
          {/* // data={plansData}
          // ids={plansIds}
          // isLoading={plansLoading}
          // fromHeader={true}
          // handleCancelSubscription={handleCancelSubscription}
          // // seachClinician={seachClinician}
          // // resendAppointmentInvite={resendAppointmentInvite}
          // // loading={loading}
          // /> */}
        </Modal>
      )}
    </Fragment>
  );
};

export default Header;
